// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-settings-template .other-integrations {
  background-color: #EBEBF4;
  padding: 30px;
  border: 1px solid #2C045D;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 1%;
}`, "",{"version":3,"sources":["webpack://./src/pages/SecurityCloudflareTurnstile/SecurityCloudflareTurnstile.scss"],"names":[],"mappings":"AACI;EACI,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAR","sourcesContent":[".ultimate-security-settings-template{\n    .other-integrations{\n        background-color: #EBEBF4;\n        padding: 30px;\n        border: 1px solid #2C045D;\n        border-radius: 3px;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 1%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
